export default {
    manage_deletedTemperature: "Temperature Alert was deleted successfully",
    manage_deletedTemperatures: "Temperature Alerts was deleted successfully",
    manage_deleteManageTemperature_deleteTemperature: "Delete Temperature Alert",
    manage_deleteManageTemperature_deleteTemperatures: "Delete Temperature Alerts",
    manage_deleteManageTemperature_confirmationMessage:
    "Are you sure you want to remove the following Temperature Alerts?",
}